import type {
  EndpointHistory,
  Overview,
  SystemHistory,
  SystemMetric,
  TimeRange
} from "./types/api";

async function getJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
    cache: "no-store",
    signal
  });
  if (!response.ok) {
    throw new Error(`请求失败，HTTP ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export function getOverview(signal?: AbortSignal): Promise<Overview> {
  return getJson<Overview>("/api/v1/overview", signal);
}

/**
 * History for one system metric. With `step` the API merges samples into buckets that
 * many seconds wide, so a week of one-minute rows arrives as a couple of hundred points.
 */
export function getSystemHistory(
  metric: SystemMetric,
  range: TimeRange,
  step?: number,
  signal?: AbortSignal
): Promise<SystemHistory> {
  const query = new URLSearchParams({ metric, range });
  if (step) query.set("step", String(step));
  return getJson<SystemHistory>(`/api/v1/history/system?${query}`, signal);
}

/** Probe history for one endpoint; `step` buckets it like `getSystemHistory`. */
export function getEndpointHistory(
  targetId: string,
  range: TimeRange,
  step?: number,
  signal?: AbortSignal
): Promise<EndpointHistory> {
  const query = new URLSearchParams({ range });
  if (step) query.set("step", String(step));
  return getJson<EndpointHistory>(
    `/api/v1/history/endpoints/${encodeURIComponent(targetId)}?${query}`,
    signal
  );
}
